import './Main.css'
import Features from './Features';

function Hero() {
  

  
  return (
    <section id="hero" className="d-flex align-items-center" >
 
    <div
      className="container position-relative" 
      data-aos="fade-up"
      data-aos-delay="100"
    >
      
      <div className="row justify-content-center">
        <div className="col-xl-7 col-lg-9 text-center">
          <h1>Buy, Sell, Send, and Receive Digital Currencies With Ease</h1>
          <h2>Seamlessly trade over 20+ digital assets, including PayPal, Alipay, Bitcoin, USDT, and more—all against your local currency. Secure, fast, and reliable.</h2>
          
          
          <div className="get-started">
        <a
          href="/login"
          className="btn-get-started"
        >
          Get Started Now
        </a>
      </div>
        </div>
      </div>
      <Features />
      
    </div>
  </section>
  );
}

export default Hero;
